import VIEWED_HOTELS_CHANGED from '../constants/viewedHotels';

export default (payload) => ({
  type: VIEWED_HOTELS_CHANGED,
  payload,
});
